function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6.658 2.2c0-.11.09-.2.2-.2h2.264c.11 0 .2.09.2.2v1.646a.2.2 0 01-.2.2H6.858a.2.2 0 01-.2-.2V2.2zM5.5 13.02c0-.11.09-.2.2-.2h.302c.27 0 .463-.058.58-.173.115-.129.173-.322.173-.58v-4.14c0-.283-.052-.49-.155-.618-.09-.129-.276-.193-.56-.193H5.7a.2.2 0 01-.2-.2v-1.28c0-.11.09-.2.2-.2h3.384c.11 0 .2.09.2.2v6.47c0 .245.051.425.154.54.116.116.303.174.56.174h.302c.11 0 .2.09.2.2v1.28a.2.2 0 01-.2.2H5.7a.2.2 0 01-.2-.2v-1.28z",
  fill: "currentColor"
})));